import { render, staticRenderFns } from "./Header4.vue?vue&type=template&id=61b8172f&scoped=true"
import script from "./Header4.vue?vue&type=script&lang=ts"
export * from "./Header4.vue?vue&type=script&lang=ts"
import style0 from "./Header4.vue?vue&type=style&index=0&id=61b8172f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8172f",
  null
  
)

export default component.exports